/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThemeGrayIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA8UlEQVR4nO2STU4CURCEB7kK8SrGMN1dLoYuNngHLzDRw7iBA2BC3MECw547aCDRuHDjmAkJzPDngG9lppJeveSrrnodRbVqFdRQ7fQEHIvxQ8FPNZ8IeJu/RX9RmqYXav6oYLZvBN5PkqRZGSiStBQ+UPirwJcCfzkE34zfVYIDfinmb78DuZWC80oGq81Pg+tqvgV81hu2j9cDX55pkBXm4ViCRQCDLIZfb29uapzmUUMYqPGpDA8FxvqqFptajLOwcJYNBHwPbSDwYTHBNLSBWedqbWDWlZB/IMb7ffcf50nE+HVeJcxrHu2cZ63/rx9bJtTx5lQHuQAAAABJRU5ErkJggg==)
 */
export const ThemeGrayIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4.13 12.02a4 4 0 0 1 5.48-4.68A5.1 5.1 0 0 1 14 5c2.61 0 4.75 1.8 4.98 4.1A5 5 0 0 1 18 19H4.5a3.5 3.5 0 0 1-.37-6.98Z"
        className={colorClass}
      />
    </svg>
  );
};
